import { create } from 'zustand';

export const useUserConfigStore = create((set) => ({
  userData: [],
  totalElements: 0,
  loading: false,
  error: null,

  setUserData: (data) => set({ userData: data }),
  setTotalElements: (total) => set({ totalElements: total }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  resetUserData: () => set({ 
    userData: [], 
    totalElements: 0, 
    loading: false, 
    error: null 
  }),
}));
